import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { useObservable } from 'react-use-observable';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import type { WalletId } from 'v2/interfaces/user';

import { getConfig, serviceMap } from './config';
import { useStyles } from './styles';

declare global {
  const SimplybookWidget: any;
}

let scriptLoaded = false;

async function loadScript() {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://widget.simplybook.me/v2/widget/widget.js';
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => {
      scriptLoaded = true;
      resolve();
    };
    script.onerror = (err) => reject(err);

    document.head.appendChild(script);
  });
}

function checkIsValidWallet(walletId: WalletId) {
  return !!serviceMap[walletId];
}

function Consultancy() {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const classes = useStyles();

  const isValidWallet = user?.wallet && checkIsValidWallet(user.wallet.id);

  React.useEffect(() => {
    if (!user?.wallet) return;
    if (!scriptLoaded && isValidWallet) {
      loadScript().then(() => {
        new SimplybookWidget(getConfig(user.wallet.id));
      });
    }
  }, [user?.wallet, isValidWallet]);

  if (!user || !user?.wallet || !isValidWallet) return null;

  return (
    <div className={classes.container}>
      <Card elevation={0} square>
        <CardContent className={classes.content}>
          <img alt='Mascote Eduzzinho voando para a esquerda cima' src='/img/eduzzinho-lancamento.png' className={classes.avatar} />
          <div className={classes.textContainer}>
            <Typography className={classes.scheduleTitle} color='inherit' component='h3' variant='h6'>
              Precisando de uma visão de negócios?
            </Typography>
            <Typography className={classes.scheduleSubtitle} color='textSecondary' component='p' variant='subtitle1'>
              Nossos analistas te direcionam com insights estratégicos e nossas soluções da plataforma.
            </Typography>
            <button className={classes.scheduleBtn} id='schedule-btn'>
              Agende agora mesmo
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export { Consultancy };
